import { StanLineChart } from '@/components/core-components/StanCharts';
import IcHelp from '@/assets/icons/ic-help-circle.svg';
import { createIconElement } from '@/lib/utils/createIconElement';
import { formatCurrency } from '@/lib/currency';
import { useBalance } from '@/queries/useBalance';
import { useUser } from '@/queries/useUser';
import { useFetchRevenueChart } from '@/queries';
import { IncomeChartTooltipContent } from './IncomeChartTooltipContent';
import { StanTooltip } from '@/components';

export const IncomeChart = ({ className = '' }: { className?: string }) => {
    const { balance } = useBalance();
    const { user } = useUser();
    const { data } = useFetchRevenueChart();

    const helpIcon = createIconElement(IcHelp, { className: 'size-5 cursor-pointer' });
    const totalRevenueAmount = balance?.total_revenue?.amount ?? 0;
    const balanceCurrency = balance?.total_revenue?.currency ?? user?.data.currency ?? 'USD';
    return (
        <div className={className}>
            <div className='flex flex-col gap-1'>
                <div className='text-gray flex gap-2'>
                    <span className='text-body-2-bold'>Total Revenue</span>
                    <StanTooltip trigger='click' position='bottom' content={<IncomeChartTooltipContent />}>
                        {helpIcon}
                    </StanTooltip>
                </div>
                <h1 className='max-2xl:text-display-display2! text-display-display1!'>
                    {formatCurrency(totalRevenueAmount, balanceCurrency)}
                </h1>
            </div>

            <StanLineChart series={data?.series} type='area' customOptions={data?.options} />
        </div>
    );
};
